module.exports = __webpack_public_path__ + "static/media/CSS basics card.20040b22.svg";